import { Box, Typography } from "@mui/material";
import { FileText } from "lucide-react";
import LinkRouter from "components/navigation/LinkRouter";
import { dateObjectToshortDate } from "common/utils";
import { AddedDocument } from "../hooks/useTaskAgentState";

export const DocumentsSection = ({
  documents,
}: {
  documents: AddedDocument[];
}) => {
  if (documents.length === 0) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <Typography variant="h4">Documents</Typography>
      {documents.map((doc, index) => {
        return (
          <LinkRouter
            sx={{ padding: "0px" }}
            key={index}
            to={`/documents/${encodeURIComponent(doc.uuid)}`}
          >
            <Box
              sx={(theme) => ({
                width: "100%",
                border: `1px solid ${theme.palette.gray[4]}`,
                borderRadius: "12px",
                padding: "16px 20px",
                transition: "background-color 0.2s ease-in-out",
                "&:hover": {
                  backgroundColor: theme.palette.gray[1],
                },
              })}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  width: "100%",
                  gap: "12px",
                }}
              >
                <FileText size={20} color="#198282" style={{ flexShrink: 0 }} />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    flex: 1,
                    minWidth: 0,
                  }}
                >
                  <Typography
                    variant="body"
                    color="text.primary"
                    sx={{
                      fontWeight: 500,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {doc.title || "Untitled"}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <Typography
                      variant="bodySmall"
                      color="text.secondary"
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {dateObjectToshortDate(
                        new Date(doc.lastUpdatedSec * 1000),
                      )}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </LinkRouter>
        );
      })}
    </Box>
  );
};
